import { api } from "@/api";

import type { SaveAccessPayload } from "../types/access";

export const getAdminDetails = async () => {
  return await api.getAdminDetails();
};

export const getAccessMatrix = async () => {
  const { data } = await api.getAccessMatrix();
  return data;
};

export const saveAccessChanges = async (payload: SaveAccessPayload) => {
  const data = await api.saveAccessChanges(payload);
  return data;
};

export const getMembers = async (groupId: string) => {
  const data = await api.msGroupMembers(groupId);
  return data as Array<{
    id: string;
    displayName: string;
    mail?: string;
    userPrincipalName: string;
  }>;
};

export const getUserTypes = async () => {
  return await api.userTypes();
};

export const getMembersByUserType = async (
  userTypeId: number
) => {
  return await api.msGroupMembersByUserType(userTypeId);
};

export const getDataRefreshStatus = async () => {
  const { data } = await api.getDataRefreshStatus();
  return data;
};

// GET user role assignments
export const getUserRoles = async (upn: string) => {
  return await api.getUserRoles(upn);
};

// GET bulk users role assignments
export const getUserRolesBulk = async (
  userPrincipalNames: string[]
) => {
  return await api.getUserRolesBulk(
    userPrincipalNames
  );
};

// POST user role assignments
export const saveUserRoles = async (payload: {
  user_principal_name: string;
  created_by:string;
  roles: { role_code: string; approval_type: "reviewer" | "approver" }[];
}) => {
  const data = await api.saveUserRoles(payload);
  return data;
};
